'use client';

// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-react/build/generate-icons

import { IconArrowExpanderLeft, iconArrowExpanderLeftTag } from '@ni/nimble-components/dist/esm/icons/arrow-expander-left';
import { wrap } from '../../utilities/react-wrapper';

export type { IconArrowExpanderLeft };
export { iconArrowExpanderLeftTag };
export const NimbleIconArrowExpanderLeft = wrap(IconArrowExpanderLeft);